import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
  notification,
} from "antd";
import { axios, getToken, URL_API } from "../../../../../utils";
import { useHttp } from "../../../../../hooks/http";
import SelectOption from "../../../pos/components/SelectOption";

const { Option } = Select;

const UnlockModal = ({ visible, onCancel, record, onSuccess }) => {
  const { Text } = Typography;
  const [detail, setDetail] = useState("");
  const [points, setPoints] = useState("");
  const [member, setMember] = useState(null);
  const source = axios.CancelToken.source();
  const [loadingMember, setLoadingMember] = useState(false);
  const [unlockType, setUnlockType] = useState(null);

  const unlockTypeOptions = [
    { value: "bill", text: "เปิดบิล" },
    { value: "cancel", text: "ยกเลิกการจอง" },
  ];

  useEffect(() => {
    if (!visible || !record?.partner_code) return;

    const fetchMember = async () => {
      setLoadingMember(true);
      setMember(null);

      try {
        const res = await axios({
          method: "get",
          baseURL: URL_API,
          url: "/point/rp/member/select-log",
          headers: { Authorization: "Bearer " + getToken() },
          params: {
            partner_code: record.partner_code,
            partner_type: record.partner_type,
            reward_id: record.id,
          },
        });

        setMember(res.data.data[0]);
        setDetail(record.description);
        setPoints(record.point);
      } catch (err) {
        console.error("โหลดข้อมูลไม่สำเร็จ", err);
      } finally {
        setLoadingMember(false);
      }
    };

    fetchMember();
  }, [visible, record]);

  const resetAll = () => {
    setMember(null);
    setPoints("");
    setDetail("");
    setUnlockType(null);
  };

  const handleSubmit = async () => {
    if (!unlockType) {
      notification.warning({
        message: "ไม่สามารถบันทึกได้",
        description: "กรุณาเลือกประเภทการปลดล็อค",
      });
      return;
    }

    try {
      const payload = {
        id: record.id,
        partner_code: member.partner_code,
        partner_name: member.partner_name,
        detail: detail,
        points: points,
        unlock_type: unlockType,
      };

      const res = await axios({
        method: "post",
        baseURL: URL_API,
        url: `/point/rp/unlock-rp`,
        headers: { Authorization: "Bearer " + getToken() },
        data: payload,
        cancelToken: source.token,
      });
      if (res?.status === 200) {
        notification.success({
          message: "สำเร็จ",
          description: "บันทึกการจองคะแนนสำเร็จ",
        });

        resetAll();
        if (onSuccess) {
          onSuccess(); 
        }
        onCancel();
      } else {
        notification.error({
          message: "ไม่สำเร็จ",
          description: res?.data?.message || "ไม่สามารถบันทึกข้อมูลได้",
        });
      }
    } catch (err) {
      notification.error({
        message: "บันทึกข้อมูลล้มเหลว",
        description: "กรุณาตรวจสอบรายการอีกรอบ",
      });
    }
  };

  return (
    <Modal
      title="ปลดล็อคการจองคะแนน"
      visible={visible}
      destroyOnClose
      onCancel={() => {
        resetAll();
        onCancel();
      }}
      footer={null}
      width={800}
    >
      <Spin spinning={loadingMember} size="large">
        <Row gutter={[16, 16]}>
          <Col span={5}>
            <Text strong>สมาชิกผู้ดำเนินการ :</Text>
          </Col>
          <Col span={11}>
            {member ? (
              <Text>{` ${member?.partner_code} ${member?.partner_name} `}</Text>
            ) : (
              "-"
            )}
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Text strong>RP พร้อมใช้ :</Text>
          </Col>
          <Col span={4}>
            <Text className="ml-3">
              {Number(member?.reward_balance || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={5}>
            <Text strong>รายละเอียด :</Text>
          </Col>
          <Col span={19}>
            <Text>{detail}</Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={5}>
            <Text strong>คะแนนที่ใช้ :</Text>
          </Col>
          <Col span={19}>
            {Math.abs(Number(points || 0)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={5}>
            <Text strong>
              <Text type="danger">*</Text> ประเภทการปลดล็อค :
            </Text>
          </Col>
          <Col span={8}>
            <SelectOption
              className="w-100"
              options={unlockTypeOptions}
              onChange={(e) => setUnlockType(e)}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col
            span={24}
            style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
          >
            <Button
              type="danger"
              ghost
              onClick={() => {
                resetAll();
                onCancel();
              }}
            >
              ยกเลิก
            </Button>
            <Button
              type="primary"
              onClick={handleSubmit}
              disabled={!unlockType}
            >
              บันทึก
            </Button>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export default UnlockModal;
